import { render, staticRenderFns } from "./RenderedBlocks.vue?vue&type=template&id=1b673035&"
import script from "./RenderedBlocks.vue?vue&type=script&lang=js&"
export * from "./RenderedBlocks.vue?vue&type=script&lang=js&"
import style0 from "./RenderedBlocks.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports